"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDashboardOpenOrders = void 0;
class ProductDashboardOpenOrders {
}
exports.ProductDashboardOpenOrders = ProductDashboardOpenOrders;
//# sourceMappingURL=product-dashboard-open-orders.response.js.map